import type { ReactNode } from 'react';
import Loan from '@/assets/svg/new/Loan';
import Rafiki from '@/assets/svg/new/Rafiki';
import Bro from '@/assets/svg/new/Bro';
import Approved from '@/assets/svg/new/Approved';
import Attendance from '@/features/products/components/hrm/mainSection/svg/Attendance';
import Recruitment from '../../hrm/mainSection/svg/new/Recruitment';
import Performance from '../../hrm/mainSection/svg/new/Performance';
import Interface from '../../hrm/mainSection/svg/new/Interface';
import Notification from '@/assets/svg/new/Notification';
import BookingSystem from '@/assets/svg/new/BookingSystem';
import BranchMange from '@/assets/svg/new/BranchMange';
import Cuate from '@/assets/svg/new/Cuate';
import ShopsReOpening from '@/assets/svg/new/ShopsReOpening';
import FileSynchronization from '@/assets/svg/new/FileSynchronization';
import Consent from '@/assets/svg/new/Consent';
import CopyRight from '@/assets/svg/new/CopyRight';
import BusinessDeal from '@/assets/svg/new/BusinessDeal';
import Invoice from '@/assets/svg/new/Invoice';
import Electric from '@/assets/svg/new/Electric';
import LocationTracking from '@/assets/svg/new/LocationTracking';
import Calendar from '@/assets/svg/new/Calendar';
import Maintenanc from '@/assets/svg/new/Maintenanc';
import Maintenance from '@/assets/svg/new/Maintenance';
import PushNotifications from '@/assets/svg/new/PushNotifications';
import Tax from '@/assets/svg/new/Tax';
import PrintingInvoices from '@/assets/svg/new/PrintingInvoices';
import FinanceApp from '@/assets/svg/new/FinanceApp';
import Finance from '@/assets/svg/new/Finance';
import Rheumatology from '@/assets/svg/new/Rheumatology';
import HospitalBed from '@/assets/svg/new/HospitalBed';
import Iymphoma from '@/assets/svg/new/Iymphoma';
import Pediatrician from '@/assets/svg/new/Pediatrician';

const wrap = (node: ReactNode) => <div className="w-full max-w-[280px] [&_svg]:h-auto [&_svg]:w-full">{node}</div>;

export const PRODUCT_FEATURE_ICON_KEYS = ['Loan', 'Rafiki', 'Bro', 'Approved'] as const;

export const productFeatureIcons: Record<string, ReactNode> = {
    Loan: wrap(<Loan />),
    Rafiki: wrap(<Rafiki />),
    Bro: wrap(<Bro />),
    Approved: wrap(<Approved />),
    attendance: wrap(<Attendance />),
    recruitment: wrap(<Recruitment />),
    performance: wrap(<Performance />),
    interface: wrap(<Interface />),
    notification: wrap(<Notification />),
    bookingSystem: wrap(<BookingSystem />),
    branchMange: wrap(<BranchMange />),
    cuate: wrap(<Cuate />),
    ShopsReOpening: wrap(<ShopsReOpening />),
    FileSynchronization: wrap(<FileSynchronization />),
    Consent: wrap(<Consent />),
    CopyRight: wrap(<CopyRight />),
    BusinessDeal: wrap(<BusinessDeal />),
    Invoice: wrap(<Invoice />),
    Electric: wrap(<Electric />),
    LocationTracking: wrap(<LocationTracking />),
    Calendar: wrap(<Calendar />),
    Maintenanc: wrap(<Maintenanc />),
    Maintenance: wrap(<Maintenance />),
    PushNotifications: wrap(<PushNotifications />),
    Tax: wrap(<Tax />),
    PrintingInvoices: wrap(<PrintingInvoices />),
    FinanceApp: wrap(<FinanceApp />),
    Finance: wrap(<Finance />),
    Rheumatology: wrap(<Rheumatology />),
    HospitalBed: wrap(<HospitalBed />),
    Iymphoma: wrap(<Iymphoma />),
    Pediatrician: wrap(<Pediatrician />),
};

export function getProductFeatureIcon(name?: string, fallbackIndex = 0) {
    if (name && productFeatureIcons[name]) {
        return productFeatureIcons[name];
    }

    const fallbackKey = PRODUCT_FEATURE_ICON_KEYS[fallbackIndex % PRODUCT_FEATURE_ICON_KEYS.length];
    return productFeatureIcons[fallbackKey];
}
